import React, { useState, useEffect } from 'react';
import { Dimensions, Image, StyleSheet, Text, View } from 'react-native';
import { isEdge, isChrome, isSafari, isMobile, isTablet, isIOS } from 'react-device-detect';
import { luxColors } from "../../../theming/themes/legacy/colors";
import DNABox from "../../layout/DNABox/DNABox";
import DNAButton from "../../controls/DNAButton/DNAButton";
import TextField from "../../controls/TextField/TextField";
import { useLDClient } from 'launchdarkly-react-client-sdk';
const styles = StyleSheet.create({
    browserIcon: {
        height: 64,
        width: 64,
    },
    browserText: {
        color: luxColors.text.secondary,
        fontSize: 15,
        marginTop: 8,
    },
    browsersWrapper: {
        flexDirection: 'row',
        marginTop: 24,
    },
    browserWrapper: {
        alignItems: 'center',
        flexDirection: 'column',
        marginRight: 24,
    },
    image: {
        height: 112,
        width: 175,
    },
    mainWrapper: {
        alignItems: 'center',
        flex: 1,
        flexDirection: 'column',
        justifyContent: 'center',
    },
    latestVersionText: {
        color: luxColors.subtitle.secondary,
        fontSize: 16,
        fontWeight: 'bold',
        textAlign: 'center',
        marginLeft: '2vw',
        marginRight: '2vw',
        maxWidth: 600,
    },
    notSupportedText: {
        color: luxColors.text.primary,
        fontSize: 24,
        marginLeft: 16,
        marginRight: 16,
        fontWeight: 'bold',
        marginBottom: 40,
        marginTop: 50,
        textAlign: 'center',
    },
    copyLinkContainer: {
        marginTop: 32,
    },
    copyLinkTextField: {
        backgroundColor: luxColors.info.primary,
        borderRadius: 8,
        borderColor: luxColors.disabled.primary,
        width: 210,
    },
});
const NOT_SUPPORTED_TEXTS = {
    beacon: {
        desktop: {
            title: 'This browser is incompatible.',
            description: 'For the best experience, Google Chrome is currently the supported browser for this application.',
            browsers: ['chrome'],
        },
        beaconWithEdge: {
            title: 'This browser is incompatible.',
            description: 'For the best experience, Google Chrome or Microsoft Edge is currently ' +
                'the supported browsers for this application.',
            browsers: ['chrome', 'edge'],
        },
        default: {
            title: 'This device is incompatible.',
            description: 'Please use the latest version of Google Chrome on a desktop or Apple Safari on an iPad.',
            browsers: ['chrome', 'safari'],
        },
        iOSTablet: {
            title: 'This browser is not supported.',
            description: 'Please use the latest version of Apple Safari.',
            browsers: ['safari'],
        },
    },
};
const BrowserChecker = (props) => {
    const { disable } = props;
    const [overrideBrowserCheck, setOverrideBrowserCheck] = useState(false);
    const [hasCopied, setHasCopied] = useState(false);
    const LDClient = useLDClient();
    const allowMsEdge = LDClient?.variation('allow-ms-edge', true) ?? true;
    const [isEdgeEnabled, setIsEdgeEnabled] = useState(allowMsEdge);
    useEffect(() => {
        setIsEdgeEnabled(allowMsEdge);
    }, [allowMsEdge]);
    useEffect(() => {
        const queryParams = new URLSearchParams(window.location.search);
        if (queryParams.get('browsercheck') && queryParams.get('browsercheck')?.toLowerCase() === 'false') {
            setOverrideBrowserCheck(true);
        }
    }, []);
    const copyLinkToClipboard = () => {
        if (hasCopied) {
            return;
        }
        navigator?.clipboard?.writeText(window.location.href)
            .then(() => {
            setHasCopied(true);
            setTimeout(() => {
                setHasCopied(false);
            }, 3000);
        })
            .catch(err => {
            console.error('Could not copy text', err);
        });
    };
    if (disable) {
        return props.children;
    }
    const isDesktopSupportedBrowser = (isChrome || (isEdgeEnabled && isEdge));
    const isDesktop = (!isMobile && !isTablet);
    const isIOSSafari = (isIOS && isSafari);
    let isSupported = true;
    let errorScenario = '';
    errorScenario = isDesktop ? 'desktop'
        : isIOS && isTablet ? 'iOSTablet'
            : 'default';
    isSupported = ((isDesktop && isDesktopSupportedBrowser) || (isTablet && isIOSSafari));
    if (overrideBrowserCheck || isSupported) {
        return <>{props.children}</>;
    }
    const windowHeight = Dimensions.get('window').height;
    const SELECTED_NOT_SUPPORTED_TEXT = NOT_SUPPORTED_TEXTS[(isEdgeEnabled && isEdge) ? 'beaconWithEdge' : 'beacon'][errorScenario];
    return (<View style={[styles.mainWrapper, { height: windowHeight }]}>
      <Image source={props.unsupportedBrowserImage} style={styles.image}/>
      <Text style={styles.notSupportedText}>
        {SELECTED_NOT_SUPPORTED_TEXT.title}
      </Text>
      <Text style={styles.latestVersionText}>
        {SELECTED_NOT_SUPPORTED_TEXT.description}
      </Text>
      <DNABox appearance="col" alignX="center" spacing="lg" style={styles.copyLinkContainer}>
        <TextField.Kitten style={styles.copyLinkTextField} value={window.location.href} editable={false}/>
        <DNAButton status={hasCopied ? 'success' : 'primary'} onPress={copyLinkToClipboard} iconLeft={hasCopied ? 'check' : undefined} size="lg">
          {hasCopied ? 'Copied' : 'Copy link'}
        </DNAButton>
      </DNABox>
    </View>);
};
export default BrowserChecker;
//# sourceMappingURL=BrowserChecker.web.js.map